import { TeamSoftware } from "./TeamSoftware.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  TeamSoftware
};
//# sourceMappingURL=index.js.map
